import { render, staticRenderFns } from "./ModificationsProgramStudent.vue?vue&type=template&id=517d7c6a&scoped=true"
import script from "./ModificationsProgramStudent.vue?vue&type=script&lang=js"
export * from "./ModificationsProgramStudent.vue?vue&type=script&lang=js"
import style0 from "@/assets/css/component/panel-simple.css?vue&type=style&index=0&id=517d7c6a&prod&scoped=true&lang=css&external"
import style1 from "./ModificationsProgramStudent.vue?vue&type=style&index=1&id=517d7c6a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "517d7c6a",
  null
  
)

export default component.exports